<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>
<app-part-info [hidden]="true"></app-part-info>


  <app-part-info [hidden]="true"></app-part-info>
<app-supply-info [hidden]="true"></app-supply-info>
<div class="pkg_status_wrap row float-right">
  <div class="col-md-7 part_current_status text-right">{{'PACKAGEID' | translate}}:
    <span class="status_review">{{routePackageID}}</span>
  </div>
  <div class="col-md-5 part_current_status">{{'STATUS' | translate}}:
    <span class="status_review" [ngClass]="{rejected:'red_alert',rejectedAndClosed:'red_alert'}[overAllPackageIDStatus]">{{displayOverallStatus}}</span>
  </div>
</div>
<form [formGroup]="packageInfoForm" #f="ngForm" novalidate>
  <section class="global_part_info pad-top-40 no-mar-lr pad-btm-20 pad-lr-15">
    <div class="row">
      <div class="col-md-4">
        <div class="form-group row">
          <label for="partNumber" class="col-sm-3 col-form-label">{{'PARTNUMBER' | translate}}
            <span class="required">*</span>
          </label>
          <div class="col-sm-6">
            <input type="text" class="form-control" formControlName="partNumber">
          </div>
        </div>
        <div class="form-group row">
          <label for="partName" class="col-sm-3 col-form-label">{{'PARTNAME' | translate}}
            <span class="required">*</span>
          </label>
          <div class="col-sm-6">
            <input type="text" class="form-control" formControlName="partName">
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group row">
          <label for="supplierCode" class="col-md-5 col-form-label">{{'SUPPLIERCODE' | translate}}
            <span class="required">*</span>
          </label>
          <div class="col-md-4">
            <input type="text" class="form-control" formControlName="supplierCode">
          </div>
        </div>
        <div class="form-group row">
          <label for="" class="col-md-5 col-form-label">{{'SUPPNAME[Jap]' | translate}}</label>
          <div class="col-md-4">
            <input type="text" class="form-control" formControlName="supplierName">
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group row" [ngClass]="{'has-error':  packageInfoForm.get('packagingProperty').invalid && f.submitted }">
          <label for="delPoints" class="col-md-4 col-form-label">{{'PKGPROPERTY' | translate}}
            <span class="required">*</span>
          </label>
          <div class="col-md-4">
            <select class="form-control" formControlName="packagingProperty">
              <option value="">{{'Select' | translate}}</option>
              <option *ngFor="let opt of packagingPropertyOpt" [value]="opt">{{opt}}</option>
            </select>
            <errors [control]="packageInfoForm.controls.packagingProperty"></errors>
            <div *ngIf="packageInfoForm.get('packagingProperty').invalid && f.submitted" class="required-error">{{'FieldRequired'
              | translate}}</div>
          </div>
        </div>

        <div class="form-group row" *ngIf="userRoleId == 4" [ngClass]="{'has-error':  packageInfoForm.get('repackaging').invalid && f.submitted }">
          <label for="" class="col-md-4 col-form-label">{{'REPACKAGING' | translate}}
            <span class="required">*</span>
          </label>
          <div class="col-md-4">
            <select class="form-control" formControlName="repackaging" [(ngModel)]="repackaging" (ngModelChange)="onRepackChange($event)">
              <option value="">{{'Select' | translate}}</option>
              <option *ngFor="let opt of repackagingOpt; let i = index" [value]="opt" [attr.selected]="opt == 'No'">{{opt}}</option>
            </select>
            <!-- <errors [control]="packageInfoForm.controls.repackaging"></errors> -->
            <div *ngIf="packageInfoForm.get('repackaging').invalid && f.submitted" class="required-error">{{'FieldRequired' | translate}}</div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="supplier_fuso_tabs mar-top-20">
    <ul class="nav nav-tabs" role="tablist">
      <li class="nav-item">
        <a class="nav-link active" data-toggle="tab" href="#supplierInfo" role="tab" [ngClass]="{'active': suppTabActive}">{{'SUPPLIERPKGINFOTAB'
          | translate}}</a>
      </li>
      <li class="nav-item" *ngIf="showFusoPkg">
        <a class="nav-link" data-toggle="tab" href="#fusoInfo" role="tab" [ngClass]="{'active': !suppTabActive}">{{'FUSO_PACK_INFO'
          | translate}}</a>
      </li>
    </ul>
    <div class="tab-content">
      <div class="tab-pane active" [ngClass]="{'active': suppTabActive}" id="supplierInfo">
        <section class="pad-lr-30 package_subtabs">
          <div class="row pad-top-30">
            <div class="col-md-4">
              <div class="form-group row" [ngClass]="{'has-error':  packageInfoForm.get('packagingCode').invalid && f.submitted}">
                <label for="" class="col-sm-6 col-form-label">{{'PKGCODE' | translate}}
                  <span class="required">*</span>
                </label>
                <div class="col-sm-6">
                  <input type="text" class="form-control packcode_input float-left" formControlName="packagingCode"
                    name="packagingCode">
                  <!-- <span class="lookup_text" data-toggle="modal" data-target="#lookupModal">Lookup </span> -->
                  <span [class.disabled]="AdminDisableBtn" class="lookup_text" (click)="openLookup(lookupModal)">{{'LOOKUP'
                    | translate}}</span>
                  <errors [control]="packageInfoForm.controls.packagingCode "></errors>
                  <div *ngIf="packageInfoForm.get('packagingCode').invalid && f.submitted" class="required-error">{{'Please select Package Code from the Lookup' | translate}}</div>
                </div>

              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group row">
                <div class="col-sm-12">
                  <span class="mar-rgt-40">
                    <i>or</i>
                  </span>
                  <a href="#" [routerLink]="['/packageDashboard/newPackage']">
                    <button [disabled]="AdminDisableBtn" type="button" class="btn btn-dark upload_img">{{'REQUESTNEWPACK'
                      | translate}}</button>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group row">
                <label for="delPoints" class="col-sm-6 col-form-label">{{'STANDARDPACKAGING' | translate}}
                  <span class="required">*</span>
                </label>
                <div class="col-sm-6">
                  <select class="form-control" formControlName="standardPackage">
                    <option value="">{{'Select' | translate}}</option>
                    <option *ngFor="let opt of standardPackageOpt" [value]="opt">{{opt}}</option>
                  </select>
                  <errors [control]="packageInfoForm.controls.standardPackage"></errors>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group row">
                <label for="delPoints" class="col-sm-6 col-form-label">{{'SPECIALIZEDPKGING' | translate}}
                  <span class="required">*</span>
                </label>
                <div class="col-sm-6">
                  <select class="form-control" formControlName="specializedPackage">
                    <option value="">{{'Select' | translate}}</option>
                    <option *ngFor="let opt of specialPackageOpt" [value]="opt">{{opt}}</option>
                  </select>
                  <errors [control]="packageInfoForm.controls.specializedPackage"></errors>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group row">
                <label for="delPoints" class="col-sm-8 col-form-label">{{'PKGNAME' | translate}}[Supplier Name]</label>
                <div class="col-sm-4">
                  <input type="text" class="form-control" formControlName="packagingName">
                  <errors [control]="packageInfoForm.controls.packagingName"></errors>
                </div>
              </div>
            </div>
            <div class="col-md-3">

            </div>
          </div>
        </section>

        <section class="mar-top-30 new_pack_dimensions pad-btm-20 pad-lr-20">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-4">
                <div class="dta_sub_title pad-btm-30">{{'INNERPKG' | translate}}</div>
                <div class="row">
                  <div class="col-md-5">
                    <div class="form-group row" [ngClass]="{'has-error': (packageInfoForm.get('innerWidth').touched || 
                    packageInfoForm.get('innerWidth').dirty) 
                    && packageInfoForm.get('innerWidth').invalid }">
                      <label for="" class="col-sm-6 col-form-label">{{'W' | translate}}
                        <span class="required">*</span>
                      </label>
                      <div class="col-sm-6">
                        <input type="text" class="form-control" formControlName="innerWidth" placeholder="">
                      </div>
                      <errors [control]="packageInfoForm.controls.innerWidth"></errors>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <div class="form-group row" [ngClass]="{'has-error': (packageInfoForm.get('innerLength').touched || 
                    packageInfoForm.get('innerLength').dirty) 
                    && packageInfoForm.get('innerLength').invalid }">
                      <label for="" class="col-sm-7 col-form-label">{{'L' | translate}}
                        <span class="required">*</span>
                      </label>
                      <div class="col-sm-5">
                        <input type="text" class="form-control" formControlName="innerLength" placeholder="">
                        <errors [control]="packageInfoForm.controls.innerLength"></errors>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-5">
                    <div class="form-group row" [ngClass]="{'has-error': (packageInfoForm.get('innerHeight').touched || 
                    packageInfoForm.get('innerHeight').dirty) 
                    && packageInfoForm.get('innerHeight').invalid }">
                      <label for="" class="col-sm-6 col-form-label">{{'H' | translate}}
                        <span class="required">*</span>
                      </label>
                      <div class="col-sm-6">
                        <input type="text" class="form-control" formControlName="innerHeight" placeholder="">
                        <errors [control]="packageInfoForm.controls.innerHeight"></errors>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <div class="form-group row">
                      <label for="" class="col-sm-7 col-form-label">{{'INNERVOL' | translate}}</label>
                      <div class="col-sm-5">
                        <input type="text" class="form-control" formControlName="innerVolume" placeholder="">
                        <errors [control]="packageInfoForm.controls.innerVolume"></errors>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 rgt_dash_brd pad-lft-20">
                <div class="dta_sub_title pad-btm-30">{{'EXTPKG' | translate}}</div>
                <div class="row">
                  <div class="col-md-5">
                    <div class="form-group row" [ngClass]="{'has-error': (packageInfoForm.get('externalWidth').touched || 
                    packageInfoForm.get('externalWidth').dirty) 
                    && packageInfoForm.get('externalWidth').invalid }">
                      <label for="" class="col-sm-6 col-form-label">{{'W' | translate}}
                        <span class="required">*</span>
                      </label>
                      <div class="col-sm-6">
                        <input type="text" class="form-control" formControlName="externalWidth" placeholder="">
                        <errors [control]="packageInfoForm.controls.externalWidth"></errors>
                      </div>
                      &nbsp;&nbsp;

                    </div>
                  </div>
                  <div class="col-md-7">
                    <div class="form-group row" [ngClass]="{'has-error': (packageInfoForm.get('externalLength').touched || 
                    packageInfoForm.get('externalLength').dirty) 
                    && packageInfoForm.get('externalLength').invalid }">
                      <label for="" class="col-sm-7 col-form-label">{{'L' | translate}}
                        <span class="required">*</span>
                      </label>
                      <div class="col-sm-5">
                        <input type="text" class="form-control" formControlName="externalLength" placeholder="">
                        <errors [control]="packageInfoForm.controls.externalLength"></errors>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-5">
                    <div class="form-group row" [ngClass]="{'has-error': (packageInfoForm.get('externalHeight').touched || 
                    packageInfoForm.get('externalHeight').dirty) 
                    && packageInfoForm.get('externalHeight').invalid }">
                      <label for="" class="col-sm-6 col-form-label">{{'H' | translate}}
                        <span class="required">*</span>
                      </label>
                      <div class="col-sm-6">
                        <input type="text" class="form-control" formControlName="externalHeight" placeholder="">
                        <errors [control]="packageInfoForm.controls.externalHeight"></errors>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <div class="form-group row" [ngClass]="{'has-error': (packageInfoForm.get('cubicMeter').touched || 
                    packageInfoForm.get('cubicMeter').dirty) 
                    && packageInfoForm.get('cubicMeter').invalid }">
                      <label for="" class="col-sm-7 col-form-label">{{'EXTVOL' | translate}}</label>
                      <div class="col-sm-5">
                        <input type="text" class="form-control" formControlName="cubicMeter" placeholder="">
                        <errors [control]="packageInfoForm.controls.cubicMeter"></errors>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 rgt_dash_brd pad-lft-20">
                <div class="dta_sub_title pad-btm-30">
                  {{'FOLDABLE' | translate}}
                  <span>
                    <label class="radio-inline pad-lft-30">
                      <input type="radio" name="isFoldable" formControlName="isFoldable" value="Yes">{{'Yes' |
                      translate}}</label>
                    <label class="radio-inline pad-lft-10">
                      <input type="radio" name="isFoldable" formControlName="isFoldable" value="No">{{'No' |
                      translate}}</label>
                  </span>

                </div>
                <div class="row">
                  <div class="col-md-5">
                    <div class="form-group row" [ngClass]="{'has-error': (packageInfoForm.get('foldableWidth').touched || 
                    packageInfoForm.get('foldableWidth').dirty) 
                    && packageInfoForm.get('foldableWidth').invalid }">
                      <label for="" class="col-sm-6 col-form-label">{{'W' | translate}}
                        <span class="required">*</span>
                      </label>
                      <div class="col-sm-6">
                        <input type="text" class="form-control" formControlName="foldableWidth" placeholder="">
                        <errors [control]="packageInfoForm.controls.foldableWidth"></errors>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <div class="form-group row" [ngClass]="{'has-error': (packageInfoForm.get('foldableLength').touched || 
                    packageInfoForm.get('foldableLength').dirty) 
                    && packageInfoForm.get('foldableLength').invalid }">
                      <label for="" class="col-sm-7 col-form-label">{{'L' | translate}}
                        <span class="required">*</span>
                      </label>
                      <div class="col-sm-5">
                        <input type="text" class="form-control" formControlName="foldableLength" placeholder="">
                        <errors [control]="packageInfoForm.controls.foldableLength"></errors>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-5">
                    <div class="form-group row" [ngClass]="{'has-error': (packageInfoForm.get('foldableHeight').touched || 
                    packageInfoForm.get('foldableHeight').dirty) 
                    && packageInfoForm.get('foldableHeight').invalid }">
                      <label for="" class="col-sm-6 col-form-label">{{'H' | translate}}
                        <span class="required">*</span>
                      </label>
                      <div class="col-sm-6">
                        <input type="text" class="form-control" formControlName="foldableHeight" placeholder="">
                        <errors [control]="packageInfoForm.controls.foldableHeight"></errors>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <div class="form-group row">
                      <label for="" class="col-sm-7 col-form-label">{{'FOLDABLEVOL' | translate}}</label>
                      <div class="col-sm-5">
                        <input type="text" class="form-control" formControlName="foldableVolume" placeholder="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div class="dta_title_brd">
        </div>
        <section class="new_pack_misc pad-top-30 pad-btm-20 pad-lr-20">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group row" [ngClass]="{'has-error': (packageInfoForm.get('loadCapacity').touched || 
                packageInfoForm.get('loadCapacity').dirty) 
                && packageInfoForm.get('loadCapacity').invalid }">
                  <label class="col-sm-6 col-form-label" for="">{{'PERMITTEDLOADCAPACITY' | translate}}
                    <span class="required">*</span>
                  </label>
                  <div class="col-sm-6">
                    <input class="form-control" formControlName="loadCapacity" placeholder="" type="text">
                    <errors [control]="packageInfoForm.controls.loadCapacity"></errors>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group row" [ngClass]="{'has-error': packageInfoForm.get('stackable').invalid && f.submitted}">
                  <label for="" class="col-sm-6 col-form-label">{{'STACKABLE' | translate}}
                    <span class="required">*</span>
                  </label>
                  <div class="col-sm-6">
                    <select class="form-control" formControlName="stackable" #s (change)="stackChange(s.value)">
                      <option value="">{{'Select' | translate}}</option>
                      <option *ngFor="let opt of returnableOpt" [value]="opt">{{opt}}</option>
                    </select>
                    <errors [control]="packageInfoForm.controls.stackable"></errors>
                    <div *ngIf="packageInfoForm.get('stackable').invalid && f.submitted" class="required-error">{{'FieldRequired'
                      | translate}}</div>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group row" [ngClass]="{'has-error': packageInfoForm.get('returnable').invalid && f.submitted}">
                  <label for="" class="col-sm-6 col-form-label">{{'RETURNABLE' | translate}}
                    <span class="required">*</span>
                  </label>
                  <div class="col-sm-6">
                    <select class="form-control" formControlName="returnable">
                      <option value="">{{'Select' | translate}}</option>
                      <option *ngFor="let opt of returnableOpt" [value]="opt">{{opt}}</option>
                    </select>
                    <errors [control]="packageInfoForm.controls.returnable"></errors>
                    <div *ngIf="packageInfoForm.get('returnable').invalid && f.submitted" class="required-error">{{'FieldRequired'
                      | translate}}</div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group row" [ngClass]="{'has-error': packageInfoForm.get('partsInBox').invalid && f.submitted}">
                  <label for="" class="col-sm-6 col-form-label">{{'PARTSINBOX' | translate}}
                    <span class="required">*</span>
                  </label>
                  <div class="col-sm-6">
                    <input class="form-control" formControlName="partsInBox" placeholder="" type="text">
                    <errors [control]="packageInfoForm.controls.partsInBox"></errors>
                    <div *ngIf="packageInfoForm.get('partsInBox').invalid && f.submitted" class="required-error">{{'FieldRequired'
                      | translate}}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3">
                <div class="form-group row" [ngClass]="{'has-error': (packageInfoForm.get('packageMaterial').touched || 
                packageInfoForm.get('packageMaterial').dirty) 
                && packageInfoForm.get('packageMaterial').invalid }">
                  <label class="col-sm-6 col-form-label" for="">{{'PKGMATERIAL' | translate}}
                    <span class="required">*</span>
                  </label>
                  <div class="col-sm-6">
                    <input class="form-control" formControlName="packageMaterial" placeholder="" type="text">
                    <errors [control]="packageInfoForm.controls.packageMaterial"></errors>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group row" [ngClass]="{'has-error': packageInfoForm.get('stackQty').invalid && f.submitted}">
                  <label class="col-sm-6 col-form-label" for="">{{'MAXSTACKQTY' | translate}}
                    <span class="required">*</span>
                  </label>
                  <div class="col-sm-6">
                    <input class="form-control" formControlName="stackQty" placeholder="" type="text">
                    <errors [control]="packageInfoForm.controls.stackQty"></errors>
                    <div *ngIf="packageInfoForm.get('stackQty').invalid && f.submitted" class="required-error">{{'FieldRequired'
                      | translate}}d</div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group row">
                  <label class="col-sm-6 col-form-label" for="">{{'MIXPACKID' | translate}}</label>
                  <div class="col-sm-6">
                    <input class="form-control" formControlName="packGroupId" placeholder="" type="text">
                    <errors [control]="packageInfoForm.controls.packGroupId"></errors>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group row">
                  <label class="col-sm-6 col-form-label" for="">{{'SETPERPKG' | translate}}
                  </label>
                  <div class="col-sm-6">
                    <input class="form-control" formControlName="setPackage" placeholder="" type="text">
                  </div>
                </div>
              </div>
            </div>

            <div class="row pad-top-20">
              <div class="col-md-3">
                <div class="form-group row">
                  <label class="col-sm-6 col-form-label" for="">{{'TAREWEIGHT' | translate}}
                    <span class="required">*</span>
                  </label>
                  <div class="col-sm-6">
                    <input class="form-control" formControlName="tareWeight" placeholder="" type="text">
                    <errors [control]="packageInfoForm.controls.tareWeight"></errors>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group row">
                  <label class="col-sm-6 col-form-label" for="">{{'CONTAINERTYPE' | translate}}
                  </label>
                  <div class="col-sm-6">
                    <!-- <select class="form-control" formControlName="containerType">
                      <option value="">Select</option>
                      <option *ngFor="let opt of containerTypeOpt" [value]="opt">{{opt}}</option>
                    </select> -->
                    <input class="form-control" formControlName="containerType" placeholder="" type="text">
                    <errors [control]="packageInfoForm.controls.containerType"></errors>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <!-- <div class="form-group row" [ngClass]="{'has-error': packageInfoForm.get('lotsSize').invalid && f.submitted}">
                  <label class="col-sm-6 col-form-label" for="">{{'LOTSIZE' | translate}}
                    <span class="required">*</span>
                  </label>
                  <div class="col-sm-6">
                    <input class="form-control" formControlName="lotsSize" placeholder="" type="text">
                    <errors [control]="packageInfoForm.controls.lotsSize"></errors>
                    <div *ngIf="packageInfoForm.get('lotsSize').invalid && f.submitted" class="required-error">{{'FieldRequired'
                      | translate}}</div>

                  </div>
                </div> -->
                <div class="form-group row">
                  <label class="col-sm-6 col-form-label" for="">{{'PARTSPERSET' | translate}}
                  </label>
                  <div class="col-sm-6">
                    <input class="form-control" formControlName="partsPerSet" placeholder="" type="text">
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group row">
                  <label for="delPoints" class="col-sm-6 col-form-label">{{'TOTALBOXWEIGHT' | translate}}</label>
                  <div class="col-sm-6">
                    <input type="text" class="form-control" formControlName="totalBoxWeight">
                    <errors [control]="packageInfoForm.controls.packagingName"></errors>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group row">
                  <label for="" class="col-sm-6 col-form-label">{{'TOTALFUSOBOXWEIGHT' | translate}}</label>
                  <div class="col-sm-6">
                    <input type="text" class="form-control" formControlName="totalFusoBoxWeight">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div class="tab-pane" [ngClass]="{'active': !suppTabActive}" id="fusoInfo" *ngIf="showFusoPkg">
        <section class="pad-lr-30 package_subtabs">
          <div class="row pad-top-30">
            <div class="col-md-4">
              <div class="form-group row" [ngClass]="{'has-error':  packageInfoForm.get('fuso_packagingCode').invalid && f.submitted}">
                <label for="" class="col-sm-6 col-form-label">{{'PKGCODE' | translate}}
                  <span class="required">*</span>
                </label>
                <div class="col-sm-6">
                  <input type="text" class="form-control packcode_input float-left" formControlName="fuso_packagingCode"
                    name="fuso_packagingCode">
                  <!-- <span class="lookup_text" data-toggle="modal" data-target="#fusoLookupModal">Lookup </span> -->
                  <span class="lookup_text" (click)="openFusoLookup(fusoLookupModal)">{{'LOOKUP' | translate}}</span>
                  <errors [control]="packageInfoForm.controls.fuso_packagingCode "></errors>
                  <div *ngIf="packageInfoForm.get('fuso_packagingCode').invalid && f.submitted" class="required-error">{{'Please select Package Code from the Lookup' | translate}}</div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group row">
                <div class="col-sm-12">
                  <span class="mar-rgt-40">
                    <i>or</i>
                  </span>
                  <a href="#" [routerLink]="['/packageDashboard/newPackage']">
                    <button type="button" class="btn btn-dark upload_img">{{'REQUESTNEWPACK' | translate}}</button>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group row">
                <label for="delPoints" class="col-sm-6 col-form-label">{{'STANDARDPACKAGING' | translate}}
                  <span class="required">*</span>
                </label>
                <div class="col-sm-6">
                  <select class="form-control" formControlName="fuso_standardPackage">
                    <option value="">{{'Select' | translate}}</option>
                    <option *ngFor="let opt of fuso_standardPackageOpt" [value]="opt">{{opt}}</option>
                  </select>
                  <errors [control]="packageInfoForm.controls.fuso_standardPackage"></errors>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group row">
                <label for="delPoints" class="col-sm-6 col-form-label">{{'SPECIALIZEDPKGING' | translate}}
                  <span class="required">*</span>
                </label>
                <div class="col-sm-6">
                  <select class="form-control" formControlName="fuso_specializedPackage">
                    <option value="">{{'Select' | translate}}</option>
                    <option *ngFor="let opt of fuso_specializedPackageOpt" [value]="opt">{{opt}}</option>
                  </select>
                  <errors [control]="packageInfoForm.controls.fuso_specializedPackage"></errors>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group row">
                <label for="delPoints" class="col-sm-8 col-form-label">{{'PKGNAME' | translate}} [Supplier Name]</label>
                <div class="col-sm-4">
                  <input type="text" class="form-control" formControlName="fuso_packagingName">
                  <errors [control]="packageInfoForm.controls.fuso_packagingName"></errors>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group row">
                <!-- to be calculated -->
                <label for="delPoints" class="col-sm-6 col-form-label">{{'TOTALBOXWEIGHT' | translate}}</label>
                <div class="col-sm-6">
                  <input type="text" class="form-control" formControlName="fuso_totalBoxWeight">
                  <errors [control]="packageInfoForm.controls.fuso_totalBoxWeight"></errors>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="mar-top-30 new_pack_dimensions pad-btm-20 pad-lr-20">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-4">
                <div class="dta_sub_title pad-btm-30">{{'INNERPKG' | translate}}</div>
                <div class="row">
                  <div class="col-md-5">
                    <div class="form-group row" [ngClass]="{'has-error': (packageInfoForm.get('innerWidth').touched || 
                    packageInfoForm.get('fuso_innerWidth').dirty) 
                    && packageInfoForm.get('fuso_innerWidth').invalid }">
                      <label for="" class="col-sm-6 col-form-label">{{'W' | translate}}
                        <span class="required">*</span>
                      </label>
                      <div class="col-sm-6">
                        <input type="text" class="form-control" formControlName="fuso_innerWidth" placeholder="">
                      </div>
                      <errors [control]="packageInfoForm.controls.fuso_innerWidth"></errors>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <div class="form-group row" [ngClass]="{'has-error': (packageInfoForm.get('fuso_innerLength').touched || 
                    packageInfoForm.get('fuso_innerLength').dirty) 
                    && packageInfoForm.get('fuso_innerLength').invalid }">
                      <label for="" class="col-sm-7 col-form-label">{{'L' | translate}}
                        <span class="required">*</span>
                      </label>
                      <div class="col-sm-5">
                        <input type="text" class="form-control" formControlName="fuso_innerLength" placeholder="">
                        <errors [control]="packageInfoForm.controls.fuso_innerLength"></errors>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-5">
                    <div class="form-group row" [ngClass]="{'has-error': (packageInfoForm.get('fuso_innerHeight').touched || 
                    packageInfoForm.get('fuso_innerHeight').dirty) 
                    && packageInfoForm.get('fuso_innerHeight').invalid }">
                      <label for="" class="col-sm-6 col-form-label">{{'H' | translate}}
                        <span class="required">*</span>
                      </label>
                      <div class="col-sm-6">
                        <input type="text" class="form-control" formControlName="fuso_innerHeight" placeholder="">
                        <errors [control]="packageInfoForm.controls.fuso_innerHeight"></errors>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <div class="form-group row">
                      <label for="" class="col-sm-7 col-form-label">{{'INNERVOL' | translate}}</label>
                      <div class="col-sm-5">
                        <input type="text" class="form-control" formControlName="fuso_innerVolume" placeholder="">
                        <errors [control]="packageInfoForm.controls.fuso_innerVolume"></errors>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 rgt_dash_brd pad-lft-20">
                <div class="dta_sub_title pad-btm-30">{{'EXTPKG' | translate}}</div>
                <div class="row">
                  <div class="col-md-5">
                    <div class="form-group row" [ngClass]="{'has-error': (packageInfoForm.get('fuso_externalWidth').touched || 
                    packageInfoForm.get('fuso_externalWidth').dirty) 
                    && packageInfoForm.get('fuso_externalWidth').invalid }">
                      <label for="" class="col-sm-6 col-form-label">{{'W' | translate}}
                        <span class="required">*</span>
                      </label>
                      <div class="col-sm-6">
                        <input type="text" class="form-control" formControlName="fuso_externalWidth" placeholder="">
                        <errors [control]="packageInfoForm.controls.fuso_externalWidth"></errors>
                      </div>
                      &nbsp;&nbsp;

                    </div>
                  </div>
                  <div class="col-md-7">
                    <div class="form-group row" [ngClass]="{'has-error': (packageInfoForm.get('fuso_externalLength').touched || 
                    packageInfoForm.get('fuso_externalLength').dirty) 
                    && packageInfoForm.get('fuso_externalLength').invalid }">
                      <label for="" class="col-sm-7 col-form-label">{{'L' | translate}}
                        <span class="required">*</span>
                      </label>
                      <div class="col-sm-5">
                        <input type="text" class="form-control" formControlName="fuso_externalLength" placeholder="">
                        <errors [control]="packageInfoForm.controls.fuso_externalLength"></errors>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-5">
                    <div class="form-group row" [ngClass]="{'has-error': (packageInfoForm.get('fuso_externalHeight').touched || 
                    packageInfoForm.get('fuso_externalHeight').dirty) 
                    && packageInfoForm.get('fuso_externalHeight').invalid }">
                      <label for="" class="col-sm-6 col-form-label">{{'H' | translate}}
                        <span class="required">*</span>
                      </label>
                      <div class="col-sm-6">
                        <input type="text" class="form-control" formControlName="fuso_externalHeight" placeholder="">
                        <errors [control]="packageInfoForm.controls.fuso_externalHeight"></errors>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <div class="form-group row" [ngClass]="{'has-error': (packageInfoForm.get('fuso_cubicMeter').touched || 
                    packageInfoForm.get('fuso_cubicMeter').dirty) 
                    && packageInfoForm.get('fuso_cubicMeter').invalid }">
                      <label for="" class="col-sm-7 col-form-label">{{'EXTVOL' | translate}}</label>
                      <div class="col-sm-5">
                        <input type="text" class="form-control" formControlName="fuso_cubicMeter" placeholder="">
                        <errors [control]="packageInfoForm.controls.fuso_cubicMeter"></errors>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 rgt_dash_brd pad-lft-20">
                <div class="dta_sub_title pad-btm-30">
                  {{'FOLDABLE' | translate}}
                  <span>
                    <label class="radio-inline pad-lft-30">
                      <input type="radio" name="fuso_isFoldable" formControlName="fuso_isFoldable" value="true">{{'Yes'
                      | translate}}</label>
                    <label class="radio-inline pad-lft-10">
                      <input type="radio" name="fuso_isFoldable" formControlName="fuso_isFoldable" value="false">{{'No'
                      | translate}}</label>
                  </span>

                </div>
                <div class="row">
                  <div class="col-md-5">
                    <div class="form-group row" [ngClass]="{'has-error': (packageInfoForm.get('fuso_foldableWidth').touched || 
                    packageInfoForm.get('fuso_foldableWidth').dirty) 
                    && packageInfoForm.get('fuso_foldableWidth').invalid }">
                      <label for="" class="col-sm-6 col-form-label">{{'W' | translate}}
                        <span class="required">*</span>
                      </label>
                      <div class="col-sm-6">
                        <input type="text" class="form-control" formControlName="fuso_foldableWidth" placeholder="">
                        <errors [control]="packageInfoForm.controls.fuso_foldableWidth"></errors>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <div class="form-group row" [ngClass]="{'has-error': (packageInfoForm.get('fuso_foldableLength').touched || 
                    packageInfoForm.get('fuso_foldableLength').dirty) 
                    && packageInfoForm.get('fuso_foldableLength').invalid }">
                      <label for="" class="col-sm-7 col-form-label">{{'L' | translate}}
                        <span class="required">*</span>
                      </label>
                      <div class="col-sm-5">
                        <input type="text" class="form-control" formControlName="fuso_foldableLength" placeholder="">
                        <errors [control]="packageInfoForm.controls.fuso_foldableLength"></errors>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-5">
                    <div class="form-group row" [ngClass]="{'has-error': (packageInfoForm.get('fuso_foldableHeight').touched || 
                    packageInfoForm.get('fuso_foldableHeight').dirty) 
                    && packageInfoForm.get('fuso_foldableHeight').invalid }">
                      <label for="" class="col-sm-6 col-form-label">{{'H' | translate}}
                        <span class="required">*</span>
                      </label>
                      <div class="col-sm-6">
                        <input type="text" class="form-control" formControlName="fuso_foldableHeight" placeholder="">
                        <errors [control]="packageInfoForm.controls.fuso_foldableHeight"></errors>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <div class="form-group row">
                      <label for="" class="col-sm-7 col-form-label">{{'FOLDABLEVOL' | translate}}</label>
                      <div class="col-sm-5">
                        <input type="text" class="form-control" formControlName="fuso_foldableVolume" placeholder="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div class="dta_title_brd">
        </div>
        <section class="new_pack_misc pad-top-30 pad-btm-20 pad-lr-20">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group row" [ngClass]="{'has-error': packageInfoForm.get('fuso_loadCapacity').invalid && f.submitted }">
                  <label class="col-sm-6 col-form-label" for="">{{'PERMITTEDLOADCAPACITY' | translate}}
                    <span class="required">*</span>
                  </label>
                  <div class="col-sm-6">
                    <input class="form-control" formControlName="fuso_loadCapacity" placeholder="" type="text">
                    <errors [control]="packageInfoForm.controls.fuso_loadCapacity"></errors>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group row" [ngClass]="{'has-error': packageInfoForm.get('fuso_stackQty').invalid && f.submitted}">
                  <label class="col-sm-6 col-form-label" for="">{{'MAXSTACKQTY' | translate}}
                    <span class="required">*</span>
                  </label>
                  <div class="col-sm-6">
                    <input class="form-control" formControlName="fuso_stackQty" placeholder="" type="text">
                    <errors [control]="packageInfoForm.controls.fuso_stackQty"></errors>
                    <div *ngIf="packageInfoForm.get('fuso_stackQty').invalid && f.submitted" class="required-error">{{'FieldRequired'
                      | translate}}</div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group row" [ngClass]="{'has-error': packageInfoForm.get('fuso_returnable').invalid && f.submitted}">
                  <label for="" class="col-sm-6 col-form-label">{{'RETURNABLE' | translate}}
                    <span class="required">*</span>
                  </label>
                  <div class="col-sm-6">
                    <select class="form-control" formControlName="fuso_returnable">
                      <option value="">{{'Select' | translate}}</option>
                      <option *ngFor="let opt of fuso_returnableOpt" [value]="opt">{{opt}}</option>
                    </select>
                    <errors [control]="packageInfoForm.controls.fuso_returnable"></errors>
                    <div *ngIf="packageInfoForm.get('fuso_returnable').invalid && f.submitted" class="required-error">{{'FieldRequired'
                      | translate}}</div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group row" [ngClass]="{'has-error': packageInfoForm.get('fuso_partsInBox').invalid && f.submitted}">
                  <label for="" class="col-sm-6 col-form-label">{{'PARTSINBOX' | translate}}
                    <span class="required">*</span>
                  </label>
                  <div class="col-sm-6">
                    <input class="form-control" formControlName="fuso_partsInBox" placeholder="" type="text">
                    <errors [control]="packageInfoForm.controls.fuso_partsInBox"></errors>
                    <div *ngIf="packageInfoForm.get('fuso_partsInBox').invalid && f.submitted" class="required-error">{{'FieldRequired'
                      | translate}}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3">
                <div class="form-group row" [ngClass]="{'has-error': (packageInfoForm.get('fuso_packageMaterial').touched || 
                packageInfoForm.get('fuso_packageMaterial').dirty) 
                && packageInfoForm.get('fuso_packageMaterial').invalid }">
                  <label class="col-sm-6 col-form-label" for="">{{'PKGMATERIAL' | translate}}
                    <span class="required">*</span>
                  </label>
                  <div class="col-sm-6">
                    <input class="form-control" formControlName="fuso_packageMaterial" placeholder="" type="text">
                    <errors [control]="packageInfoForm.controls.fuso_packageMaterial"></errors>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group row">
                  <label class="col-sm-6 col-form-label" for="">{{'MIXPACKID' | translate}}</label>
                  <div class="col-sm-6">
                    <input class="form-control" formControlName="fuso_packGroupId" placeholder="" type="text">
                    <errors [control]="packageInfoForm.controls.fuso_packGroupId"></errors>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group row" [ngClass]="{'has-error': packageInfoForm.get('fuso_stackable').invalid && f.submitted}">
                  <label for="" class="col-sm-6 col-form-label">{{'STACKABLE' | translate}}
                    <span class="required">*</span>
                  </label>
                  <div class="col-sm-6">
                    <select class="form-control" formControlName="fuso_stackable">
                      <option value="">{{'Select' | translate}}</option>
                      <option *ngFor="let opt of fuso_stackableOpt" [value]="opt">{{opt}}</option>
                    </select>
                    <errors [control]="packageInfoForm.controls.fuso_stackable"></errors>
                    <div *ngIf="packageInfoForm.get('fuso_stackable').invalid && f.submitted" class="required-error">{{'FieldRequired'
                      | translate}}</div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group row">
                  <label class="col-sm-6 col-form-label" for="">{{'SETPERPKG' | translate}}
                  </label>
                  <div class="col-sm-6">
                    <input class="form-control" formControlName="fuso_setPackage" placeholder="" type="text">
                  </div>
                </div>
              </div>
            </div>

            <div class="row pad-top-20">
              <div class="col-md-3">
                <div class="form-group row">
                  <label class="col-sm-6 col-form-label" for="">{{'TAREWEIGHT' | translate}}
                    <span class="required">*</span>
                  </label>
                  <div class="col-sm-6">
                    <input class="form-control" formControlName="fuso_tareWeight" placeholder="" type="text">
                    <errors [control]="packageInfoForm.controls.fuso_tareWeight"></errors>

                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group row">
                  <label class="col-sm-6 col-form-label" for="">{{'CONTAINERTYPE' | translate}}
                  </label>
                  <div class="col-sm-6">
                    <!-- <select class="form-control" formControlName="containerType">
                      <option value="">Select</option>
                      <option *ngFor="let opt of containerTypeOpt" [value]="opt">{{opt}}</option>
                    </select> -->
                    <input class="form-control" formControlName="fuso_containerType" placeholder="" type="text">
                    <errors [control]="packageInfoForm.controls.fuso_containerType"></errors>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <!-- <div class="form-group row" [ngClass]="{'has-error': packageInfoForm.get('fuso_lotsSize').invalid && f.submitted}">
                  <label class="col-sm-6 col-form-label" for="">{{'LOTSIZE' | translate}}
                    <span class="required">*</span>
                  </label>
                  <div class="col-sm-6">
                    <input class="form-control" formControlName="fuso_lotsSize" placeholder="" type="text">
                    <errors [control]="packageInfoForm.controls.fuso_lotsSize"></errors>
                    <div *ngIf="packageInfoForm.get('fuso_lotsSize').invalid && f.submitted" class="required-error">{{'FieldRequired'
                      | translate}}</div>

                  </div>
                </div> -->
                <div class="form-group row">
                  <label class="col-sm-6 col-form-label" for="">{{'PARTSPERSET' | translate}}
                  </label>
                  <div class="col-sm-6">
                    <input class="form-control" formControlName="fuso_partsPerSet" placeholder="" type="text">
                  </div>
                </div>
              </div>

              <div class="col-md-3">

              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="dta_title_brd"></div>
    <section class="new_package mar-top-20 pad-lr-20">
      <div class="container-fluid">
        <div class="row mar-top-10">
          <div class="col-md-5">
            <div class="dta_sub_title pad-btm-10">{{'COUNTERMEASURE' | translate}}</div>
            <div class="form-group row mar-top-30" [ngClass]="{'has-error': packageInfoForm.get('rust').invalid && f.submitted}">
              <label for="" class="col-sm-4 col-form-label">{{'RUST' | translate}}
                <span class="required">*</span>
              </label>
              <div class="col-sm-4">
                <select class="form-control" formControlName="rust">
                  <option value="">{{'Select' | translate}}</option>
                  <option *ngFor="let opt of rustOpt" [value]="opt">{{opt}}</option>
                </select>
                <errors [control]="packageInfoForm.controls.rust"></errors>
                <div *ngIf="packageInfoForm.get('rust').invalid && f.submitted" class="required-error">{{'FieldRequired'
                  | translate}}</div>
              </div>
            </div>
            <div class="form-group row" [ngClass]="{'has-error':  packageInfoForm.get('interference').invalid && f.submitted}">
              <label for="" class="col-sm-4 col-form-label">{{'INTERFERENCE' | translate}}
                <span class="required">*</span>
              </label>
              <div class="col-sm-4">
                <select class="form-control" formControlName="interference">
                  <option value="">{{'Select' | translate}}</option>
                  <option *ngFor="let opt of interferenceOpt" [value]="opt">{{opt}}</option>
                </select>
                <errors [control]="packageInfoForm.controls.interference"></errors>
                <div *ngIf="packageInfoForm.get('interference').invalid && f.submitted" class="required-error">{{'FieldRequired'
                  | translate}}</div>
              </div>
            </div>
            <div class="form-group row" [ngClass]="{'has-error':  packageInfoForm.get('cleanliness').invalid && f.submitted}">
              <label for="" class="col-sm-4 col-form-label">{{'CLEANLINESS' | translate}}
                <span class="required">*</span>
              </label>
              <div class="col-sm-4">
                <select class="form-control" formControlName="cleanliness">
                  <option value="">{{'Select' | translate}}</option>
                  <option *ngFor="let opt of cleanlinessOpt" [value]="opt">{{opt}}</option>
                </select>
                <errors [control]="packageInfoForm.controls.cleanliness"></errors>
                <div *ngIf="packageInfoForm.get('cleanliness').invalid && f.submitted" class="required-error">{{'FieldRequired'
                  | translate}}</div>
              </div>
            </div>
          </div>
          <div class="col-md-7">
            <div class="dta_sub_title pad-btm-10">{{'CONTAINER' | translate}}</div>
            <div class="form-group row mar-top-30">
              <label for="" class="col-md-6 col-form-label">{{'MASTERDATASHEETUPLOAD' | translate}}
                <br />
                <p class="text-danger" *ngIf="isDuplicationMasterFilename"><b>{{'Duplicate' | translate}}</b></p>
                <div class="upload_img_legend text-left pad-top-5">{{'RECOMMENDED_TWO_FILES' | translate}}</div>
              </label>
              <div class="col-md-6 text-center">
                <p-fileUpload #masterform name="imageFiles[]" auto="true" mode="advanced" maxFileSize="10000000"
                  fileLimit="1" customUpload="true" (uploadHandler)="uploadMasterData($event, masterform)" [disabled]="disableSubmit"
                  chooseLabel="{{'Choose' | translate}}"></p-fileUpload>
              </div>
            </div>
            <div class="row" *ngFor="let img of pkgImageDetails">
              <div class="col-md-6 text-left pad-btm-10" *ngIf="img.isMasterDataSheet == true">
                <a *ngIf="img.imageUri" href="{{img?.imageUri+saas_token}}" class="pkgImg_link">{{img?.imageName}}</a>
                <!-- <span *ngIf="masterUploadProgress" class="blinking">{{'Please wait, Uploading file(s) ...' |
                  translate}}</span> -->
              </div>
              <div class="col-md-6 text-right pad-btm-10" *ngIf="img.isMasterDataSheet == true">
                <button *ngIf="img.imageUri" class="btn btn-dark" (click)="openImgDelCfm(img, imgdelModal)" [disabled]="disableSubmit">{{'DELETE'
                  | translate}}</button>
              </div>
            </div>
            <div class="form-group row mar-top-30">
              <label for="" class="col-md-6 col-form-label">{{'PICTUREUPLOAD' | translate}}
                <br />
                <p class="text-danger" *ngIf="isDuplicationpackageFilename"><b>{{'Duplicate' | translate}}</b></p>
                <div class="upload_img_legend pad-top-5">{{'RECOMMENDED_TO_UPLOAD' | translate}}</div>
              </label>
              <div class="col-md-6 text-center">
                <p-fileUpload #pkgform name="imageFiles[]" auto="true" mode="advanced" maxFileSize="10000000" fileLimit="5"
                  fileLimitMessage="Only 5 image" accept="image/*" customUpload="true" (uploadHandler)="uploadPackageImg($event, pkgform)"
                  [disabled]="disableSubmit" chooseLabel="{{'Choose' | translate}}"></p-fileUpload>
              </div>
            </div>
            <div class="row" *ngFor="let img of pkgImageDetails">
              <div class="col-md-6 text-left pad-btm-10" *ngIf="img.isMasterDataSheet != true">
                <a *ngIf="img.imageUri" href="{{img?.imageUri+saas_token}}" class="pkgImg_link">{{img?.imageName}}</a>
                <!-- <span *ngIf="pkgimgUploadProgress" class="blinking">{{'Please wait, Uploading file(s) ...' |
                  translate}}</span> -->
              </div>
              <div class="col-sm-6 text-right pad-btm-10" *ngIf="img.isMasterDataSheet != true">
                <button *ngIf="img.imageUri" class="btn btn-dark" (click)="openImgDelCfm(img, imgdelModal)" [disabled]="disableSubmit">{{'DELETE'
                  | translate}}</button>
              </div>
            </div>
          </div>
        </div>
        <div class="row pad-tb-30 top_dash_brd action_section">
          <div class="col-md-3 text-center">
            <button type="submit" class="btn btn-dark" (click)=savePkgInfo(1,null) [disabled]="disableSubmit" id="pkgInfoSave">{{'SAVE'
              | translate}}</button>
          </div>
          <div class="col-md-3 text-left" *ngIf="showRevisedSubmit">
            <button type="submit" class="btn btn-dark" data-target="#" (click)="openStatusRevisedModal(statusRevised)"
              [disabled]="disableSubmit" id="pkgInfoSubmit">{{'SUBMIT' | translate}}</button>
          </div>
          
          <div class="col-md-6 text-left" *ngIf="!showRevisedSubmit">
            <button type="submit" class="btn btn-dark" data-target="#" (click)="openStatusModal(statusChange)"
              [disabled]="disableSubmit" id="pkgRevisionSubmit">{{'SUBMIT' | translate}}</button>
          </div>

          <div class="col-md-3 text-left" *ngIf="validate">
            <button type="submit" class="btn btn-info" data-target="#" (click)="reValidate(statusChange)"
              [disabled]="disableRevalidate" id="pkgInfoSubmit">Validate</button>
          </div>
        </div>
      </div>
    </section>
  </section>
</form>

<!-- Lookup Modal -->
<ng-template class="modal fade" #lookupModal let-c="close" let-d="dismiss">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="lookupModalLabel">{{'LOOKUPPKGCODE' | translate}}</h5>
      <button type="button" class="close" (click)="d('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row mar-tb-20">
        <div class="col-md-5 part_current_status">
          {{'PACKAGEID' | translate}}: {{routePackageID}}
        </div>
      </div>
      <div class="codeList mar-top-20">
        <p-table [value]="packageLookup" selectionMode="single" [responsive]="true" [rows]="10" [paginator]="true" [pageLinks]="3"
          [rowsPerPageOptions]="[10,25,50,100]" [(selection)]="pkgselect">
          <!-- <p-column [style]="{'width':'40px'}" selectionMode="single"></p-column>
          <p-column field="packageCode" header="{{'PKGCODE' | translate}}" [sortable]="true" [filter]="true"
            filterPlaceholder="{{'SEARCH_PKG_CODE' | translate}}"></p-column>
          <p-column field="externalPackDimL" header="{{'LENGTH' | translate}}" [sortable]="true" [filter]="true"
            filterPlaceholder="{{'SEARCH_LENGTH' | translate}}"></p-column>
          <p-column field="externalPackDimW" header="{{'WIDTH' | translate}}" [sortable]="true" [filter]="true"
            filterPlaceholder="{{'SEARCH_WIDTH' | translate}}"></p-column>
          <p-column field="externalPackDimH" header="{{'HEIGHT' | translate}}" [sortable]="true" [filter]="true"
            filterPlaceholder="{{'SEARCH_HEIGHT' | translate}}"></p-column>
          <p-column field="totalMaxWeightBox" header="{{'WEIGHT' | translate}}" [sortable]="true" [filter]="true"
            filterPlaceholder="{{'SEARCH_WEIGHT' | translate}}"></p-column> -->
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 42px">
                  <!-- <p-tableHeaderCheckbox></p-tableHeaderCheckbox> -->
              </th>
  
                  <th pSortableColumn="packageCode" style="width:20%">{{'PKGCODE' | translate}} <p-sortIcon field="packageCode"></p-sortIcon></th>
                  <th pSortableColumn="externalPackDimL" style="width:20%">{{'LENGTH' | translate}} <p-sortIcon field="externalPackDimL"></p-sortIcon></th>
                  <th pSortableColumn="externalPackDimW" style="width:20%">{{'WIDTH' | translate}}<p-sortIcon field="externalPackDimW"></p-sortIcon></th>
                  <th pSortableColumn="externalPackDimH" style="width:20%">{{'HEIGHT' | translate}} <p-sortIcon field="externalPackDimH"></p-sortIcon></th>
                  <th pSortableColumn="totalMaxWeightBox" style="width:20%">{{'WEIGHT' | translate}} <p-sortIcon field="totalMaxWeightBox"></p-sortIcon></th>
              </tr>
              <tr>
                <th>

                </th>
                <th>
                  <p-columnFilter type="text" field="packageCode"></p-columnFilter>
              </th>
              <th>
                <p-columnFilter type="text" field="externalPackDimL"></p-columnFilter>
               </th>
               <th>
              <p-columnFilter type="text" field="externalPackDimW"></p-columnFilter>
              </th>
              <th>
                 <p-columnFilter type="text" field="externalPackDimH"></p-columnFilter>
               </th>
              <th>
                  <p-columnFilter type="text" field="totalMaxWeightBox"></p-columnFilter>
             </th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-value>
              <tr [pSelectableRow]="value">
                <td>
                  <p-tableCheckbox [value]="value"></p-tableCheckbox>
              </td>
                  <td>{{value.packageCode}}</td>
                  <td>{{value.externalPackDimL}}</td>
                  <td>{{value.externalPackDimW}}</td>
                  <td>{{value.externalPackDimH}}</td>
                  <td>{{value.totalMaxWeightBox}}</td>
              </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="modal-footer mar-top-10">
      <div class="row lookup_footer no-pad">
        <div class="col-md-6">
          <button type="button" class="btn btn-dark mar-rgt-10" (click)="showLookupData()">{{'SELECTCODE' |
            translate}}</button>
          <button type="button" class="btn btn-dark-brd" (click)="c('Cross click')">{{'CANCEL' | translate}}</button>
        </div>
        <div class="col-md-6 text-right">
          <button type="button" class="btn btn-dark upload_img" (click)="vLookupNewPkg()">{{'REQUESTNEWPACK' |
            translate}}</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<!-- Fuso Lookup Modal -->
<ng-template class="modal fade" #fusoLookupModal let-c="close" let-d="dismiss">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="lookupModalLabel">{{'Lookup Fuso Package Code' | translate}}</h5>
      <button type="button" class="close" (click)="d('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row mar-tb-20">
        <div class="col-md-5 part_current_status">
          {{'PACKAGEID' | translate}}: {{routePackageID}}
        </div>
      </div>
      <div class="codeList mar-top-20">
        <p-table [value]="fusoPackageLookup" selectionMode="single" [responsive]="true" [rows]="10" [paginator]="true" [pageLinks]="3"
          [rowsPerPageOptions]="[5,10,20]" [(selection)]="fusoPkgselect">
          <!-- <p-column [style]="{'width':'42px'}" selectionMode="single"></p-column>
          <p-column [style]="{'width':'150px'}" field="fusoPackageCode" header="{{'PKGCODE' | translate}}" [sortable]="true"
            [filter]="true" filterPlaceholder="{{'SEARCH_PKG_CODE' | translate}}"></p-column>
          <p-column field="externalPackDimL" header="{{'LENGTH' | translate}}" [sortable]="true" [filter]="true"
            filterPlaceholder="{{'SEARCH_LENGTH' | translate}}"></p-column>
          <p-column field="externalPackDimW" header="{{'WIDTH' | translate}}" [sortable]="true" [filter]="true"
            filterPlaceholder="{{'SEARCH_WIDTH' | translate}}"></p-column>
          <p-column field="externalPackDimH" header="{{'HEIGHT' | translate}}" [sortable]="true" [filter]="true"
            filterPlaceholder="{{'SEARCH_HEIGHT' | translate}}"></p-column>
          <p-column field="totalMaxWeightBox" header="{{'WEIGHT' | translate}}" [sortable]="true" [filter]="true"
            filterPlaceholder="{{'SEARCH_WEIGHT' | translate}}"></p-column> -->
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 42px">
                  <!-- <p-tableHeaderCheckbox></p-tableHeaderCheckbox> -->
              </th>
  
                  <th pSortableColumn="fusoPackageCode" style="width:20%">{{'SEARCH_PKG_CODE' | translate}} <p-sortIcon field="fusoPackageCode"></p-sortIcon></th>
                  <th pSortableColumn="externalPackDimL" style="width:20%">{{'LENGTH' | translate}} <p-sortIcon field="externalPackDimL"></p-sortIcon></th>
                  <th pSortableColumn="externalPackDimW" style="width:20%">{{'WIDTH' | translate}}<p-sortIcon field="externalPackDimW"></p-sortIcon></th>
                  <th pSortableColumn="externalPackDimH" style="width:20%">{{'HEIGHT' | translate}} <p-sortIcon field="externalPackDimH"></p-sortIcon></th>
                  <th pSortableColumn="totalMaxWeightBox" style="width:20%">{{'WEIGHT' | translate}} <p-sortIcon field="totalMaxWeightBox"></p-sortIcon></th>
              </tr>
              <tr>
                <th>

                </th>
                <th>
                  <p-columnFilter type="text" field="fusoPackageCode"></p-columnFilter>
              </th>
              <th>
                <p-columnFilter type="text" field="externalPackDimL"></p-columnFilter>
               </th>
               <th>
              <p-columnFilter type="text" field="externalPackDimW"></p-columnFilter>
              </th>
              <th>
                 <p-columnFilter type="text" field="externalPackDimH"></p-columnFilter>
               </th>
              <th>
                  <p-columnFilter type="text" field="totalMaxWeightBox"></p-columnFilter>
             </th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-value>
              <tr  [pSelectableRow]="value">
                <td>
                  <p-tableCheckbox  [value]="value"></p-tableCheckbox>
              </td>
                  <td>{{value.fusoPackageCode}}</td>
                  <td>{{value.externalPackDimL}}</td>
                  <td>{{value.externalPackDimW}}</td>
                  <td>{{value.externalPackDimH}}</td>
                  <td>{{value.totalMaxWeightBox}}</td>
              </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="modal-footer mar-top-10">
      <div class="row lookup_footer no-pad">
        <div class="col-md-6">
          <button type="button" class="btn btn-dark mar-rgt-10" (click)="showLookupFusoData()">{{'SELECTCODE' |
            translate}}</button>
          <button type="button" class="btn btn-dark-brd" (click)="c('Cross click')">{{'CANCEL' | translate}}</button>
        </div>
        <div class="col-md-6 text-right">
          <button type="button" class="btn btn-dark upload_img" (click)="vLookupNewPkg()">{{'REQUESTNEWPACK' |
            translate}}</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>



<!-- Part Number History Modal -->
<ng-template #history let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Part Number History</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Page Under Construction ..</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="c('Close click')">Close</button>
  </div>
</ng-template>

<!-- Approve/Reject Modal -->

<ng-template #statusChange let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">{{'NEXT_PHASE_APPROVAL' | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>
      {{'SELECT_STATUS' | translate}}
    </p>
    <div class="row mar-btm-20">
      <div class="col-md-12">
        <select class="form-control" [(ngModel)]="status" (ngModelChange)="onStatusChange($event)">
          <option value="0">{{'Select' | translate}}</option>
          <option value="1" *ngIf="adminAccess != 9">{{'APPROVE' | translate}}</option>
          <option value="2" *ngIf="overAllPackageIDStatus != 'rejected' && adminAccess == 2 || adminAccess == 3 || adminAccess == 4 || adminAccess == 5 || adminAccess == 6 || adminAccess == 7 ">{{'REJECT'
            | translate}}</option>

          <option value="5" *ngIf="adminAccess == 9">{{'Overall Approve' | translate}}</option>
          <option value="6" *ngIf="adminAccess == 9">{{'Approve - On Behalf of Supplier' | translate}}</option>
          <!-- <option value="3" *ngIf="overAllPackageIDStatus == 'rejected'">Closed</option>
          <option value="4" *ngIf="overAllPackageIDStatus == 'approvedAndClosed'">Closed</option> -->
        </select>
      </div>
    </div>
    <div class="row mar-top-20" *ngIf="showStatusComment">
      <div class="col-md-12">
        <textarea class="form-control" [(ngModel)]="statusComment" (ngModelChange)="onCommentEnter($event)" maxlength="100"></textarea>
      </div>
      <p class="error" [hidden]="statusComment?.length < 100">{{'You have exceeded maximum character limit' |
        translate}}</p>
      <div [hidden]="!showStatusError" class="error">
        <p>
          {{'Please enter your comment for rejection.' | translate}}
        </p>
      </div>
    </div>
    <div class="row mar-top-20" *ngIf="!showStatusComment">
      <div class="col-md-12">
        <textarea class="form-control" [(ngModel)]="statusComment" (ngModelChange)="onCommentEnter($event)" maxlength="100"></textarea>
      </div>
      <p class="error" [hidden]="statusComment?.length < 100">{{'You have exceeded maximum character limit' |
        translate}}</p>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-dark" (click)="submitPackage()">Ok</button>
    <button type="button" class="btn btn-dark-brd" (click)="c('Close click')">{{'CANCEL' | translate}}</button>
  </div>
</ng-template>


<!-- Package Revised Modal -->

<ng-template #statusRevised let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">{{'PkgModalTitle' | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>
      {{'COMMENTS' | translate}}
    </p>
    <div class="row mar-top-20">
      <div class="col-md-12">
        <textarea class="form-control" [(ngModel)]="revisedComment" (ngModelChange)="onrevisedComment($event)"></textarea>
      </div>
      <div [hidden]="!revisedCommentError" class="error">
        <p>
          {{'Please enter your comments.' | translate}}
        </p>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row btnIEFix">
      <div class="col-md-12 text-left">
        <button type="button" class="btn btn-dark" (click)="submitPackage(1)">{{'SUBMIT' | translate}}</button>
        <button type="button" class="btn btn-dark-brd" (click)="c('Close click')">{{'CANCEL' | translate}}</button>
      </div>
    </div>
  </div>
</ng-template>


<!-- Part Image deletion confirmation Modal -->

<ng-template #imgdelModal let-c="close" let-d="dismiss" style="z-index: 999999999;">
  <div class="modal-header">
    <h4 class="modal-title">{{'confirm_box' | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>{{'Delete_confirmation' | translate}}?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn btn-dark" (click)="deletePartImg()">{{'Yes' | translate}}</button>
    <button type="button" class="btn btn-outline-dark" (click)="c('Close click')">{{'No' | translate}}</button>
  </div>
</ng-template>
